import Vue from 'vue';
import VueRouter from 'vue-router';
import Meta from 'vue-meta';
import { createSandbox } from 'vue-kindergarten';
import routes from '@/routes';
import store from '@/store';
import { perimeters } from '@/kindergarten/perimeters';
import RouteGoverness from '@/kindergarten/governesses/RouteGoverness';
import child from '@/kindergarten/child';
// import { loadLanguageAsync } from '@/plugins/vue-i18n';

Vue.use(VueRouter);
Vue.use(Meta);

export const router = new VueRouter({
  mode: 'history',
  routes,
});
router.beforeEach((to, from, next) => {
  // const lang = to.params.lang;
  // loadLanguageAsync(lang).then(() => next());
  router.app.$Progress.start();
  store.dispatch('auth/check'); // not sure if it is the right way to prevent redirect if session is over TODO: refresh token on each request
  // if (to.matched.some(m => m.meta.auth) && !store.state.auth.authenticated) {
  //   /*
  //    * If the user is not authenticated and visits
  //    * a page that requires authentication, redirect to the login page
  //    */
  //   next({
  //     name: 'login.index',
  //   });
  // } else if (to.matched.some(m => m.meta.guest) && store.state.auth.authenticated) {
  //   /*
  //    * If the user is authenticated and visits
  //    * an guest page, redirect to the dashboard page
  //    */
  //   next({
  //     name: 'home.index',
  //   });
  // } else {
  //   next();
  // }
  to.matched.some((routeRecord) => {
    const perimeter = perimeters[routeRecord.meta.perimeter];
    const Governess = routeRecord.meta.governess || RouteGoverness;
    const action = routeRecord.meta.perimeterAction || 'route';
    if (perimeter) {
      const sandbox = createSandbox(child(store), {
        governess: new Governess(routeRecord.meta.perimeter),

        perimeters: [
          perimeter,
        ],
      });

      return sandbox.guard(action, { to, from, next });
    }

    return next();
  });
});

router.afterEach(() => {
  //  finish the progress bar
  router.app.$Progress.finish();
});

Vue.router = router;

export default {
  router,
};



// WEBPACK FOOTER //
// ./src/plugins/vue-router.js